import React, {memo, useEffect, useRef, useState} from 'react';
import {useDispatch, useSelector} from 'react-redux';
import {actions} from "../../models/stores/actions";
import CustomizeTravelBtn from '../CustomizeTravelBtn';
import { isMath, isNormalZhEnCss} from '../../utils';

import  * as TYPES  from '../../models/types';

import styles from './styles.module.scss';

import frameIconW from '../../assets/img/public/frameiconw.svg';

const Index = memo((props) => {

  const dispatch = useDispatch();
  const {basicOtherModelrEvent} = actions;

  const recReSizeReducer = useSelector(({recReSizeReducer}) => recReSizeReducer.value);
  const basicDrawerReducer = useSelector(({basicDrawerReducer}) => basicDrawerReducer);
  const { travelMall, lang } = useSelector(({localesReducer}) => localesReducer.i18n);

  const { options } = useSelector(({basicDrawerReducer}) => basicDrawerReducer);

  const [ tabKey, setTabKey ] = useState('T001');

  const [pricingToogle, setPricingToogle] = useState(false);
  const [faqToogle, setFaqToogle] = useState(false);
  const [bookingInstructionsToogle, setBookingInstructionsToogle] = useState(false);

  // 样式判断
  const normal = () => {
    if(recReSizeReducer > 1920){
      return isNormalZhEnCss(lang, 'English') ? styles.normalXl2En : styles.normalXl2;
    }

    if(recReSizeReducer > 1440 && recReSizeReducer <= 1920){
      return isNormalZhEnCss(lang, 'English') ? styles.normalXlEn : styles.normalXl;
    }

    if(recReSizeReducer > 1024 && recReSizeReducer <= 1440){
      return isNormalZhEnCss(lang, 'English') ? styles.normalLgEn : styles.normalLg;
    }

    if(recReSizeReducer > 750 && recReSizeReducer <= 1024){
      return isNormalZhEnCss(lang, 'English') ? styles.normalMdEn : styles.normalMd;
    }

    if(recReSizeReducer <= 750){
      return isNormalZhEnCss(lang, 'English') ? styles.normalSmEn : styles.normalSm;
    }
  };

  // 导航
  const tabs = () => {
    return (
        <div 
          className="tabsNavs"
          ref={props.config.getRefs.innerNavsRef}
          style={props.config.getRefs.innerNavsStyle}
        >
          <ul className="navList">
            {travelMall.absNavsData.list.map(item => {
            return (<li onClick={() => handleClickTabNav(item)} key={item.id} className={item.id === tabKey ? 'innerLiActive' : null}><span>{item.name}</span></li>);
          })}
          </ul>
            <div className="enquiry">
              <span>{travelMall.absNavsData.enquiry}</span>
              <i><img src={frameIconW} alt="" /></i>
            </div>
        </div>
    );
  };


  // Tabs/position
  const handleClickTabNav = (item) => {
    // 定位跳转
    document.querySelector(`#${item.jumpName}`).scrollIntoView(true); 
    setTabKey(item.id);
  };

  // 行程方案
  const currentInnerRef = useRef(null);


  // 行程方案
  const newTravelItinerary = () => {
    const { index } = options;
    if(options.type){
      const { newTravelItinerary: {title, list } } = travelMall[options.type].list[index];
      const len = list.length - 1;
      return (
          <div 
            className="newTravelItinerary"
            name={'jumpTravelItinerary'} 
            id={'jumpTravelItinerary'}
            ref={props.config.getRefs.innerNewTravelItineraryRef}
            style={props.config.getRefs.innerNewTravelItineraryStyle}
          >
            <h5>{title}</h5>
            <div className='newTravelItineraryBox'>
                {list.map((item, index) => {
                  const inlineCss = index === 0 ? null : {
                    background: '#CDA876',
                    width: isMath(recReSizeReducer, 1),
                  }

                  const lineCss = index === 0 ? null : {
                    background: index === len ? '#FFF' : '#CDA876',
                    height: '100%',
                  }

                  return (
                    <div key={item.id} className="currentInner" ref={currentInnerRef}>
                      <ul className='list'>
                        <li style={inlineCss}>
                          <div className="line" style={lineCss}><div className="rectangle"><i></i></div></div>
                        </li>
                        <li><i>{item.id}</i></li>
                        <li>
                          <div className='innerBox'>
                            <div className='address'>
                              {item.address.map(aitem => {
                                return (<strong key={aitem.key}>{aitem.name}</strong>)
                              })}
                            </div>
                            <div className='eatDesc'>
                              {item.descs.map(ditem => {
                                return (
                                  <div className='eatItem' key={ditem.num}>
                                    <i><img src={ditem.icon} alt=''/></i>
                                    <em>{ditem.name}</em>
                                  </div>
                                )
                              })}
                            </div>
                          </div>
                        </li>
                      </ul>
                    </div>
                  )
                })}
            </div>
          </div>
      );
      
    }
    
  };

  // 能过按钮来控制当前的内容展开有收起
  const innerHeaderContentRen = ({title, btnText, toogle, handleEvent}) => {
    const isVisible = {
      visibility: options.type === TYPES.BOOKINGINSTRUCTIONS || options.type === TYPES.FAQ ? 'hidden' : 'visible'
    }
    
    return (
      <div className='innerHeaderContent'>
        <div className='title'><h5>{title}</h5></div>
        <div className='btnToogle' onClick={handleEvent} style={isVisible}>
          <span>{btnText}</span>
          <i className='icon'>
            <svg width="12" height="12" viewBox="0 0 12 12" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path d="M11 5.99951L1 5.99951" stroke="#333333" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
              {toogle ? null : <path d="M6 11L6 1" stroke="#333333" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>}
            </svg>
          </i>
        </div>
      </div>
    );
  }


  // 价格内容
  const pricing = () => {
    const {
      pricingData,
      pricingMainData,
      expenseDescriptionData,
    } = travelMall;
    // const status = 1; // 中文/还是英文
    const status = isNormalZhEnCss(lang, 'English') ? 2 : 1; // 中文/还是英文


    const currentInnerStyle = {
      // height: pricingToogle ? 'auto' : '0px',
      visibility: pricingToogle ? 'visible' : 'hidden',
      opacity: pricingToogle ? 1 : 0,
      transition: `all .5s`,
    }

    
    return (
        <div 
          className="pricing" 
          name={'jumpPricing'} 
          id={'jumpPricing'}
          ref={props.config.getRefs.innerPricingRef}
          // style={props.config.getRefs.innerPricingStyle}
        >
          {innerHeaderContentRen({title: pricingData.title , toogle: pricingToogle,  btnText: 'Expand', handleEvent: () => setPricingToogle(!pricingToogle)})}
          {
            pricingToogle ? (
              <div className="currentInner" style={currentInnerStyle}>
                {pricingData.list.map((item, index) => {
                  return (
                      <div key={index} className="row">
                        <i><img src={item.img} alt="" /></i>
                        {
                          recReSizeReducer > 750 ? (
                              item.children.map( (k, i) => (<span key={i}>{k.name}</span>))
                            ) : (
                              status ? (
                                  <div className="prRow">{item.children.map((k, i) => <span key={i}>{k.name}</span>)}</div>
                              ) : (
                                  item.children.map( (k, i) => <span className="prSpan" key={i}>{k.name}</span>
                                  )
                              )
                            )
                        }
                      </div>
                  );
                })}
              </div>
            ) : null
          }
         
          {
             pricingToogle ? (
              <div className="currentDesc" style={currentInnerStyle}>
                {
                  pricingMainData.map((item, index) => {
                    return (
                        <div key={index} className="row">
                          <div className="col"><span>{item.title.name}</span></div>
                          <div className="col">
                            {
                              item.list.map(k => {
                                return (
                                    <div className="textRow" key={k.id}>
                                      <p><span>{k.title}</span></p>
                                      <p><span>{k.subTitle}</span></p>
                                    </div>
                                );
                              })
                            }
                          </div>
                        </div>
                    )
                  })
                }
              </div>
             ) : null
          }
          
          {
            pricingToogle ? (
              <div className="expenseDescription" style={currentInnerStyle}>
                {
                  expenseDescriptionData.map((item, index) => {
                    return (
                        <div key={index} className="row">
                          <div className="col"><span>{item.title.name}</span></div>
                          <div className="col">
                            {
                              item.list.map(k => {
                                return (
                                    <div className="textRow" key={k.id}>
                                      <p><span>{k.desc}</span></p>
                                    </div>
                                );
                              })
                            }
                          </div>
                        </div>
                    )
                  })
                }
              </div>
            ) : null
          }
          
        </div>
    );
  };

  // 定制流程
  const groupServerPM = (customizationProcessData) => {
    return recReSizeReducer > 750 ? (
        <div 
          className="groupServer" 
          name={'jumpCustomizationProcess'} 
          id={'jumpCustomizationProcess'}
        >
          <div className="serverCard">
            {customizationProcessData.texInfoList.map(item => {
              return <i key={item.id}><img src={item.icon} alt="" /></i>
            })}
          </div>
          <div className="lineNum">
            <div className="rowLine">
              <i>1</i>
              <i>2</i>
              <i>3</i>
            </div>
          </div>
          <div className="textInfo">
            {
              customizationProcessData.texInfoList.map((item, index) => {
                  return (
                      <div key={index} className="infoCard">
                        <div className="innerText">
                          {item.children.map((kTem, i) => (<p key={i}><span>{kTem.name}</span></p>))}
                        </div>
                      </div>
                  );
              })
            }
          </div>
          <div className='innerGroupBtn'>
            <CustomizeTravelBtn
                config={{
                  title: customizationProcessData.btnText,
                  handleEvent: () => {
                    dispatch(basicOtherModelrEvent({
                      otherVisible: TYPES.OTHERDRAWERSHOW,
                      otherOptions: {
                        status: 0,
                      },
                    }));
                  }
                }}
            />
          </div>
        </div>
    ):(
        <div className="groupServer">
          <div className="textInfo">
            {customizationProcessData.texInfoList.map((item, i) => {
              let index = i + 1;
              return (
                  <div key={index} className="infoCard">
                    <div className="serverCard">
                      <i><img src={item.icon} alt="" /></i>
                    </div>
                    <div className="lineNum">
                      <i>{index}</i>
                    </div>
                    <div className="innerText">
                      {
                        item.children.map((kTem, j) => {
                          return (<p key={j}><span>{kTem.name}</span></p>);
                        })
                      }
                    </div>
                  </div>
              )
            })
          }
          </div>
          <div className='innerGroupBtn'>
            <CustomizeTravelBtn
                config={{
                  title: customizationProcessData.btnText,
                  handleEvent: () => {
                    dispatch(basicOtherModelrEvent({
                      otherVisible: TYPES.OTHERDRAWERSHOW,
                      otherOptions: {
                        status: 0,
                      },
                    }));
                  }
                }}
            />
          </div>
        </div>
    )
  }
  const customizationProcess = () => {
    const {
      customizationProcessData,
    } = travelMall;

    const isImg = recReSizeReducer > 750 ? customizationProcessData.img : customizationProcessData.imgM;
    return (
        <div 
          className="customizationProcess"
          ref={props.config.getRefs.innerCustomizationProcessRef}
          style={{
            background: `url(${isImg}) no-repeat 100% 100% / cover`,
            ...props.config.getRefs.innerCustomizationProcessStyle
          }}
        >
          <h5 className="title"><span>{customizationProcessData.title.name}</span></h5>
          <p className="subTitle"><span>{customizationProcessData.title.desc}</span></p>
          <div className="currentInner">{groupServerPM(customizationProcessData)}</div>
        </div>
    );
  };

  // 常见问题
  const faq = () => {
    const {
      faqData,
    } = travelMall;
    const { options } = basicDrawerReducer;
    const num = recReSizeReducer <= 750 ? 100 : 160;
    const faqCss = options.type === TYPES.FAQ ? {paddingTop: isMath(recReSizeReducer, num)} : null;


    const isTypes = options.type === TYPES.BOOKINGINSTRUCTIONS || options.type === TYPES.FAQ ? true : faqToogle;

    const currentInnerStyle = {
      visibility: isTypes ? 'visible' : 'hidden',
      opacity: isTypes ? 1 : 0,
      transition: `all .5s`,
    }

    return (
        <div 
          className="faq" 
          ref={props.config.getRefs.innerFaqRef}
          style={{...faqCss, /* ...props.config.getRefs.innerFaqStyle */}} 
          name={'jumpFAQ'} 
          id={'jumpFAQ'}
        >
          {innerHeaderContentRen({title: faqData.title , toogle: faqToogle,  btnText: 'Expand', handleEvent: () => setFaqToogle(!faqToogle)})}
          {
            isTypes ? (
              <div className="currentInner" style={currentInnerStyle}>
                {
                  faqData.list.map((item) => {
                      return (
                          <div key={item.id} className="row">
                            <div className="col"><i><img src={item.icon} alt=""/></i></div>
                            <div className="col">
                              <h6><span>{item.title}</span></h6>
                              {
                                Array.isArray(item.children) ? (
                                    <div className="desc">
                                      {
                                        item.children.map((k) => {
                                          return (<p><span id={k.id}>{k.desc}</span></p>)
                                        })
                                      }
                                    </div>
                                ) : null
                              }
                            </div>
                          </div>
                      );
                    })
                }
              </div>
            ) : null
          }
          
        </div>
    );
  };

  // 预定说明
  const bookingInstructionsRender = (list) => {
    return list.map((item, index) => {
      return (
          <div key={index} className="row">
            <div className="innerTitle">
              <i><img src={item.instruction.icon} alt="" /></i>
              <span>{item.instruction.desc}</span>
            </div>
            <div className="descList">
              <ul>
                {
                  item.instruction.innerList.map((k, ki) => {
                      return (
                          <li key={ki}>
                            <p><span className={k.subTitle.type ?'spanNormal' : null}>{k.subTitle.desc}</span></p>
                            {
                              k.subTitle.children ? k.subTitle.children.map((j, ji) => {
                                  return (
                                      <dl key={ji}>
                                        <dt><span>{j.desc}</span></dt>
                                        {j.children ? j.children.map((s,si) => (<dd key={si}><span>{s.desc}</span></dd>)) : null}
                                      </dl>
                                  );
                              }) : null
                          }
                          </li>
                      );
                  })
                }
              </ul>
            </div>
          </div>
      )
    });
  }
  const bookingInstructions = () => {
    const { options } = basicDrawerReducer;
    const num = recReSizeReducer <= 750 ? 100 : 160;
    const bitrCss = options.type === TYPES.BOOKINGINSTRUCTIONS ? {paddingTop: isMath(recReSizeReducer, num)} : null;
    const {
      bookingInstructionsData: {
        title,
        list,
      }
    } = travelMall;

    const isTypes = options.type === TYPES.BOOKINGINSTRUCTIONS || options.type === TYPES.FAQ ? true : bookingInstructionsToogle;

    const currentInnerStyle = {
      visibility: isTypes ? 'visible' : 'hidden',
      opacity: isTypes ? 1 : 0,
      transition: `all .5s`,
    }
    return (
        <div 
          className="bookingInstructions" 
          ref={props.config.getRefs.innerBookingInstructionsRef}
          style={{...bitrCss, /* ...props.config.getRefs.innerBookingInstructionsStyle */}} 
          name={'jumpTBookingInstructions'} 
          id={'jumpTBookingInstructions'}
        >
          {innerHeaderContentRen({title: title , toogle: bookingInstructionsToogle,  btnText: 'Expand', handleEvent: () => setBookingInstructionsToogle(!bookingInstructionsToogle)})}
          
          {
            isTypes ? (
              <div className="currentInner" style={currentInnerStyle}>
                {bookingInstructionsRender(list)}
              </div>
            ) : null
          }
         
        </div>
    );
  }

  const isTour = () => {
    const { options } = basicDrawerReducer;
    if(options.doTour){
      const { doTour } = options;
      if(doTour === TYPES.TRAVELMALL){
        const { type } = options;
        if(type){
          switch(type){
            case TYPES.domesticTourType:
              return true;
            case TYPES.overseasTourType:
              return true;
            default: 
              return false;  
          }
        }
      }else{
        return false;
      }
    }
  }

  const otherContent = () => {
    return (
      <>
          {/*行程方案 Travel Itinerary*/}
          {newTravelItinerary()}
          {/*价格内容 Pricing*/}
          {pricing()}
          {/*定制流程 Customization Process */}
          {customizationProcess()}
      </>
    )
  }


  const isFaqBookingInstructions = () => {
    const { options } = basicDrawerReducer;
    if(options.type){
      if(options.type === TYPES.FAQ){
        return faq();
      }else if(options.type === TYPES.BOOKINGINSTRUCTIONS){
        return bookingInstructions();
      }else if(options.type === TYPES.domesticTourType || options.type === TYPES.overseasTourType){
        return (
            <>
              {faq()}
              {bookingInstructions()}
            </>
        );
      }
    }
  }

  // 行程方案
  const tabsMain = () => {
    return (
        <>
          {isTour() ? otherContent() : null}
          {/*常见问题 FAQ / 预定说明 Booking Instructions*/}
          {isFaqBookingInstructions()}
        </>
    );
  }

  const isTabs = () => {
    return isTour() ? tabs() : null
  }

  return (
      <div className={normal()}>
        {recReSizeReducer <= 750 ? null : isTabs()}
        {tabsMain()}
      </div>
  );
});
export default Index;
